import React from "react";
import { Card, Table, Icon, Divider, Button, Form, message } from 'antd';

import NHFetch from "../../../utils/NHFetch";
import { getLoginUser } from "../../../utils/NHCore";
import { NHConfirm } from '../../common/NHModal';
import PropTypes from "prop-types";

const hjdm = "GD002";   //环节代码
const basicUrl = "/yxxc/";
const jfxtBasicUrl = 'api/zhxg-jfxt/';


class Jfbl extends React.Component {
    constructor() {
        super()
        this.state = {
            editable: true,
            basicdata: [],
            studentData: {},
            loading: false
        }
    }

    componentWillReceiveProps(nextProps) {
        if ('studentData' in nextProps) {
            const studentData = nextProps.studentData;

            //查询到学生信息时才显示绿色通道环节办理业务项
            if (Object.keys(studentData).length != 0) {
                //查询到不同学生
                if (JSON.stringify(this.state.studentData) === '{}' || this.state.studentData !== studentData) {
                    this.setState({ studentData: studentData });
                    NHFetch('api/zhxg-xtgl/schoolMng/queryDqxx', 'GET').then(res => {
                        if (res && res.code === 200) {
                            //如果是项目地，则需要先进行同步缴费信息
                            this.syncStuChargeInfo(res.data.xxdm, studentData);
                        }
                    })
                }
                this.setState({ show: true });

            } else {
                this.setState({ show: false });
            }
        }

        if ('hjblztData' in nextProps) {
            const hjblztData = nextProps.hjblztData;
            if (hjblztData) {
                let editable = hjblztData.blzt == '1' ? false : true;
                this.setState({ hjblztData: hjblztData, editable: editable });
            } else {
                this.setState({ hjblztData: hjblztData, editable: true });
            }
        }

    }
    /**
     * 同步第三方平台学生缴费信息
     */
    syncStuChargeInfo = (xxdm, studentData) => {

        switch (xxdm) {
            //武汉铁路
            case '12977': {
                NHFetch(`api/zhxg-jfxt/axf/syncStuChargeInfo/${studentData.xsid}`, 'GET').then(res => {
                    if (res && res.code == 200) {
                        if (![0, 3, 5].includes(res.data.code)) {
                            message.warn(res.data.msg);
                        }
                        if ((res.data.code === 0 || res.data.code === 3) && this.props.hjblztData.blzt === '0') {
                            this.handleSubmit();
                        }
                        this.getJfblxx(studentData);
                    }
                });
                break;
            }
            // 长沙电力职业技术学院
            case '13938': {
                NHFetch(`api/zhxg-jfxt/openapi/syncChargeInfoFromBankOfChangsha`, 'GET', { xsid: studentData.xsid }).then(res => {
                    if (res && res.code == 200) {
                        let { status, msg } = res.data;
                        if (status != '00' && status != '02') {
                            message.warn(msg);
                        }
                        if (status == '00' && this.props.hjblztData.blzt === '0') {
                            this.handleSubmit();
                        }
                        this.getJfblxx(studentData);
                    }
                });
                break;
            }
            default:
                this.getJfblxx(studentData);
                break;
        }

    }

    /**
     * * 获取缴费办理业务信息
     *
     * @memberof Lstd
     */
    getJfblxx = (studentData) => {
        const { xsid } = studentData;

        // NHFetch(jfxtBasicUrl + 'yxjk/getJfblxx', 'GET', { xsid: xsid })
        //     .then(res => {
        //         const basicdata = res.data.map(item => {
        //             return { id: item.PKID, name: item.SFXMMC, yjje: item.YSJE, yjnje: item.SSJE, remark: item.PKID };
        //         });

        //         this.setState({ basicdata: basicdata });
        //     });



        NHFetch('api/zhxg-yxwz/jfxtUnauth/yxwzjfxx/getJfxxListForXc', 'GET', { xsid: xsid })
            .then(resData => {
                if (resData && resData.data) {
                    this.setState({ basicdata: resData.data })
                }
            });

    }


    handleSubmit = () => {
        const { pkid } = this.state.hjblztData;
        const { xsid } = this.props.studentData;

        if (!xsid) {
            message.error("环节办理失败,请先查询学生信息！");
            return;
        }

        let userId = getLoginUser() ? getLoginUser().userId : '';
        let params = { xsid: xsid, lchjid: pkid, yhbh: userId, hjdm: hjdm };
        this.setState({ loading: true });
        NHFetch(basicUrl + 'saveCustomLinkData', 'POST', params)
            .then(res => {
                if (res) {
                    if (res.data == '1') {
                        message.success('环节办理成功！');
                        //办理完成回调
                        const onFinish = this.props.onFinish;
                        if (onFinish) {
                            onFinish('submit');
                        }
                        this.setState({ loading: false });
                    } else {
                        message.error('环节办理失败，请重试！');
                        this.setState({ loading: false });
                    }
                }
                this.setState({ loading: false });
            }).catch((ress) => {
                this.setState({ loading: false });
            })
    };

    handleCancel = () => {
        const { pkid } = this.state.hjblztData;
        const { xsid } = this.state.studentData;
        let userId = getLoginUser() ? getLoginUser().userId : ''; 
        let params = { xsid: xsid, hjdm: hjdm, yhbh: userId,  lchjid: pkid };

        NHConfirm("是否确定取消办理？", () => {
            this.setState({ loading: true });
            NHFetch(basicUrl + 'cancelCustomLinkData', 'POST', params)
                .then(res => {
                    if (res) {
                        if (res.data == '1') {
                            message.success('环节办理取消成功！');
                            //取消办理完成回调
                            const onFinish = this.props.onFinish;
                            if (onFinish) {
                                onFinish('cancel');
                            }
                            this.setState({ loading: false });
                        } else {
                            message.error('环节办理取消失败，请重试！');
                            this.setState({ loading: false });
                        }
                    }
                    this.setState({ loading: false });
                }).catch((ress) => {
                    this.setState({ loading: false });
                })
        }, "warn");
    }

    //打印报到单回调
    handlePrint = () => {
        let onPrint = this.props.onPrint;
        if (onPrint) {
            onPrint();
        }
    }

    //上一步
    handleLast = () => {
        let onLast = this.props.onLast;
        if (onLast) {
            onLast();
        }
    }

    //下一步
    handleNext = () => {
        let onNext = this.props.onNext;
        if (onNext) {
            onNext();
        }
    }


    render() {
        const { editable, loading } = this.state;
        const { lchjData = {}, hasLast, hasNext } = this.props;

        const { sfdybdd = '0' } = lchjData; //是否打印报到单

        const columns = [
            // {
            //     name: '收费项目',
            //     dataIndex: 'name',
            //     key: 'name',
            // }, {
            //     title: '应缴金额（元）',
            //     dataIndex: 'yjje',
            //     key: 'yjje',
            // }, {
            //     title: '已缴金额（元）',
            //     dataIndex: 'yjnje',
            //     key: 'yjnje',
            // }, {
            //     title: '是否缴清',
            //     dataIndex: 'sfjq',
            //     key: 'sfjq',
            //     render: (text, record) => (
            //         record.yjje - record.yjnje == 0 ? <span><Icon type="check-circle" style={{ color: '#4BC819' }} /> <a
            //             href="javascript:;">已缴清</a></span> :
            //             record.yjje - record.yjnje > 0 && record.id == 'total' ?
            //                 <span style={{ color: '#ff0000' }}> 欠费 {record.yjje - record.yjnje} 元</span> :
            //                 <span style={{ color: '#ff0000' }}><Icon type="exclamation-circle"
            //                     style={{ color: '#FAAE13' }} /> 欠费</span>
            //     )
            // }
            {
                title: '收费项目',
                dataIndex: 'SFXMMC',
            },
            {
                title: '应缴金额（元）',
                dataIndex: 'YSJE',
            },
            {
                title: '已缴金额（元）',
                dataIndex: 'SSJE',
                render: (text, record) => {
                    return <span>{text}</span>;
                }
            },
            {
                title: '缓交金额（元）',
                dataIndex: 'JMJE',
                render: (text, record) => {
                    return <span>{record.JMJE ? record.JMJE : (record.HJJE ? record.HJJE : '0')}</span>;
                }
            },
            {
                title: '欠费金额（元）',
                dataIndex: 'QFJE',
                render: (text, record) => {
                    if (text > 0) {
                        return <span className="text-info-red">{text}</span>
                    } else {
                        return text
                    }
                }
            }
        ];

        let data = [];

        const basicdata = this.state.basicdata;
        // const basicdata = [
        if (basicdata.length) {
            let yjje = 0;
            let yjnje = 0;
            let hjje = 0;
            let qfje = 0;
            basicdata.forEach((item) => {
                yjje += Number(item.YSJE);
                yjnje += Number(item.SSJE);
                hjje += Number(item.JMJE);
                qfje += Number(item.QFJE);
            });
            data = basicdata.concat({
                SFXMMC: '合计',
                YSJE: yjje,
                SSJE: yjnje,
                JMJE: hjje,
                QFJE: qfje
            });
        }


        return (
            <div>
                <Card type="inner" title="缴费办理业务信息">
                    <Table
                        style={{ marginBottom: 24 }}
                        pagination={false}
                        dataSource={data}
                        columns={columns}
                        rowKey="id"
                    />
                </Card>
                <Divider style={{ margin: '40px 0 24px' }} />
                {editable ? <Button type="primary" onClick={this.handleSubmit} loading={loading}>确认办理</Button> :
                    <Button type="primary" onClick={this.handleCancel} loading={loading}>取消办理</Button>
                }
                {
                    sfdybdd == '1' ? <Button type="primary" loading={this.props.loading} ghost style={{ marginLeft: 10 }} onClick={this.handlePrint}>打印报到单</Button> : null
                }
                {
                    hasLast ?
                        <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleLast}>上一步</Button>
                        : null
                }
                {
                    hasNext ?
                        <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleNext}>下一步</Button>
                        : null
                }
            </div>
        )
    }
}


Jfbl.propTypes = {
    studentData: PropTypes.object, //学生信息
    hjblztData: PropTypes.object, //环节办理状态信息
    lchjData: PropTypes.object, //流程环节信息数据
    hasLast: PropTypes.bool, //是否有上一步
    hasNext: PropTypes.bool, //是否有下一步
    onLast: PropTypes.func, //上一步事件回调
    onNext: PropTypes.func, //下一步事件回调
    onFinish: PropTypes.func, //确认办理、取消办理完成回调
    onPrint: PropTypes.func, //打印报到单
}
const jfbl = Form.create()(Jfbl);
export default Jfbl;


// WEBPACK FOOTER //
// ./components/yxxc/steps/jfbl.js